import { resolveAgentQuestionOptionSendText } from './resolveAgentQuestionOptionSendText.js'

export function buildAgentQuestionConfirmPayload(question, selection) {
  const option = question.options.find((item) => item.id === selection.optionId)
  const sendText = resolveAgentQuestionOptionSendText(selection.optionId, selection.freeText)
  return {
    text: sendText,
    files: [],
    agentQuestionAnswer: {
      questionId: question.id,
      optionId: selection.optionId,
      optionLabel: option?.label || '',
      freeText: selection.freeText || '',
      sendText,
    },
  }
}

export function handleAgentQuestionConfirm(question, selection, onSendMessage) {
  const payload = buildAgentQuestionConfirmPayload(question, selection)
  if (!payload.text.trim()) return
  onSendMessage?.(payload)
}
